module.exports = __webpack_public_path__ + "static/media/Oct10-F18.14b81cee.png";